import {
  Button,
  Dialog,
  DialogContent,
  DialogTrigger,
  InputFieldProps,
} from "@bleu.builders/ui";
import { CirclePlus } from "lucide-react";
import React from "react";

import { SettingsCard } from "#/components/SettingsCard";

const DAY_IN_MS = 86_400 * 1000;

const THIRDY_DAYS_FROM_NOW = new Date(Date.now() + 30 * DAY_IN_MS);

const AddCreditsModal = ({ organization }) => {
  const fields = [
    {
      name: "amount",
      label: "Créditos",
      description: "Quantidade de créditos a serem adicionados",
      type: "input",
      mode: "number",
    },
    {
      name: "expires_at",
      label: "Data de expiração",
      description: "Data de expiração dos créditos",
      type: "date",
    },
  ] as InputFieldProps[];

  return (
    <SettingsCard
      title="Adicionar créditos"
      fields={fields}
      defaultValues={{
        amount: 0,
        expires_at: THIRDY_DAYS_FROM_NOW,
      }}
      actionText="Adicionar"
      _method="post"
      method="post"
      action={{
        path: `/admin/organizations/${organization.id}/assign_credits`,
      }}
      useFormSubmit
    />
  );
};

export function ManuallyAssignCreditsButton({ organization }) {
  return (
    <div className="size-full flex gap-10 flex-col">
      <Dialog>
        <DialogTrigger asChild>
          <Button className="bg-primary/20 text-primary border border-primary hover:bg-primary/10">
            <CirclePlus size={16} className="mr-2" />
            Adicionar créditos manualmente
          </Button>
        </DialogTrigger>
        <DialogContent className="max-h-[90%] max-w-lg overflow-auto">
          <AddCreditsModal organization={organization} />
        </DialogContent>
      </Dialog>
    </div>
  );
}
